import FlyCountView from './FlyCountView';

export default FlyCountView;
